var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircularDeleteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 1,
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fde6e7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8461 10.3845H22.6922V11.923H21.1538V21.923C21.1538 22.127 21.0727 22.3227 20.9285 22.4669C20.7842 22.6112 20.5886 22.6922 20.3845 22.6922H9.61531C9.4113 22.6922 9.21564 22.6112 9.07138 22.4669C8.92712 22.3227 8.84608 22.127 8.84608 21.923V11.923H7.30762V10.3845H11.1538V8.07685C11.1538 7.87284 11.2348 7.67718 11.3791 7.53292C11.5233 7.38866 11.719 7.30762 11.923 7.30762H18.0768C18.2809 7.30762 18.4765 7.38866 18.6208 7.53292C18.765 7.67718 18.8461 7.87284 18.8461 8.07685V10.3845ZM19.6153 11.923H10.3845V21.1538H19.6153V11.923ZM12.6922 14.2307H14.2307V18.8461H12.6922V14.2307ZM15.7692 14.2307H17.3076V18.8461H15.7692V14.2307ZM12.6922 8.84608V10.3845H17.3076V8.84608H12.6922Z",
    fill: "#EE000E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircularDeleteIcon);
export default __webpack_public_path__ + "static/media/circular-delete-icon.447ee08793c22e986ee30cd1f910c4be.svg";
export { ForwardRef as ReactComponent };